import React from "react";
import { amountLabel } from "../../../services/Units";

// Spojena celija za grupu dana: chipovi dana (mogu se iskljuciti) + obroci tih dana
export const DAY_SHORT = {
    monday: "Pon", tuesday: "Uto", wednesday: "Sre", thursday: "\u010cet",
    friday: "Pet", saturday: "Sub", sunday: "Ned"
};

const mealToLine = (meal) => {
    if (!meal) return null;
    const parts = [];
    if (meal.recipes) meal.recipes.forEach(r => r && r.value && parts.push(r.value));
    if (meal.groceries) meal.groceries.forEach(g => {
        if (g && g.value) parts.push(g.servingSize ? `${g.value} - ${amountLabel(g.servingSize, g.unit)}` : g.value);
    });
    return parts.length ? parts.join(" + ") : null;
};

const PlanTableCellMerged = ({ planData, mealIndex, days, toggleMergedDay }) => {
    const lines = [];
    days.forEach(day => {
        const meal = planData && planData[day] ? planData[day][mealIndex] : null;
        const line = mealToLine(meal);
        if (line && !lines.includes(line)) lines.push(line);
    });

    return (
        <td colSpan={days.length} className="relative py-3 px-2 xl:px-4 font-medium text-sm align-top">
            <div className="flex flex-wrap justify-center gap-1 mb-2">
                {days.map(day => (
                    <label key={day} className="flex items-center text-[10px] bg-bluePrimary bg-opacity-10 rounded px-1.5 py-0.5 cursor-pointer select-none">
                        <input type="checkbox" className="mr-1 accent-blueSecondary cursor-pointer" checked readOnly onClick={() => toggleMergedDay(mealIndex, day)} />
                        {DAY_SHORT[day]}
                    </label>
                ))}
            </div>
            {lines.length ?
                lines.map((line, i) => (
                    <div className="border bg-white border-bluePrimary border-opacity-20 rounded mt-2 first:mt-0 py-1.5 px-2 text-center text-xs font-semibold" key={i}>
                        {line}
                    </div>
                ))
                :
                <div className="text-center text-xs text-gray-400 italic py-2">
                    Nema obroka u spojenim danima.
                </div>
            }
        </td>
    );
};

export default PlanTableCellMerged;
